import axios from 'axios';
import qs from 'qs';
import mockUrls from '../mock/url-config';
import handleError from './handle-error';
import handleSuccess from './handle-success';
import cfg from 'src/config';
import {getToken,toLogin} from 'src/commons';
import { message} from 'antd';
import { useState, useEffect, useRef } from "react";

const { ajaxPrefix, ajaxTimeout } = cfg;

const Axios = axios.create({
    baseURL: "/service", // 设置请求的base url
    timeout: ajaxTimeout, // 设置超时时长
})

// 请求前拦截
Axios.interceptors.request.use(config => {
    const token = getToken();
    config.headers = {
       "Content-Type": "application/json",
    };
    if(token) {
      config.headers = {
          "Authorization": token,
          "Content-Type": "application/json",
      };
    }
    return config
}, err => {
    return Promise.reject(err)
})

// 返回后拦截
Axios.interceptors.response.use(res => {
    // 判断当前请求是否设置了不显示Loading
    if(res && res.data.code === 200){
        return {success: true, data: res.data.data };
    }else{
        if(res && res.data.code === 401){
            toLogin();
            return;
        }else{
            handleError({error: res.data, errorTip: '系统异常'});
            return {success: false, data: res.data.data };
        }
    }
}, error => {
	handleError({ error, errorTip: '请求异常'});
    return Promise.reject(error)
})

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
const get = function(url, params){
    return new Promise((resolve, reject) =>{
        Axios.get(url, {params: params})
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err)
        })
    });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
const post = function(url, params){
    return new Promise((resolve, reject) => {
        Axios.post(url, params)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err)
        })
    });
}

const getSystem = function(url, params){
    return new Promise((resolve, reject) =>{
        Axios.get("/kunpeng-system/"+url, {params: params})
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err)
        })
    });
}

const postSystem = function(url, params){
    return new Promise((resolve, reject) => {
        Axios.post("/kunpeng-system/"+url, params)
        .then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err)
        })
    });
}

const successNotify = function(message){
    handleSuccess({successTip: message ? message : '操作成功'});
}

export default {get, post,getSystem, postSystem,successNotify};
